// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import { node } from 'prop-types'
import React from 'react'
import useHandleApplicationMaintenanceWindow from './hooks/useHandleApplicationMaintenanceWindow'
import MaintenanceWindowActiveMessage from './MaintenanceWindowActiveMessage'

const WithMaintenanceWindow = ({ children }) => {
  const isWithinMaintenanceWindow = useHandleApplicationMaintenanceWindow()

  return (
    isWithinMaintenanceWindow
      ? <MaintenanceWindowActiveMessage/>
      : children
  )
}

WithMaintenanceWindow.propTypes = {
  children: node.isRequired,
}

export default WithMaintenanceWindow
